import {filterByComponents} from './filterByComponents';
import {filterByCategories} from './filterByCategories';


export default {
    filterByComponents,
    filterByCategories
}